import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Calendar, Mail, Phone, User, Download, RefreshCw } from 'lucide-react';
import { exportToCSV, formatDate } from '../../lib/admin/utils';

const BookingsTab = ({ bookings, loading, onRefresh }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Consultation Bookings</h2>
      <div className="flex gap-2">
        <Button onClick={onRefresh} variant="outline" size="sm">
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </Button>
        <Button
          onClick={() => exportToCSV(bookings, 'consultation-bookings')}
          className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900"
          size="sm"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </Button>
      </div>
    </div>

    {loading ? (
      <div className="text-center py-12">Loading...</div>
    ) : bookings.length === 0 ? (
      <Card>
        <CardContent className="py-12 text-center text-gray-500">
          No consultation bookings yet
        </CardContent>
      </Card>
    ) : (
      <div className="space-y-4">
        {bookings.map((booking) => (
          <Card key={booking._id || `${booking.email}-${booking.createdAt}`} className="hover:shadow-lg transition-shadow">
            <CardContent className="pt-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <User className="w-4 h-4 text-gray-500" />
                    <span className="font-semibold text-lg">
                      {booking.firstName} {booking.lastName}
                    </span>
                    <Badge variant={booking.status === 'pending' ? 'default' : 'secondary'}>
                      {booking.status}
                    </Badge>
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex items-center gap-2">
                      <Mail className="w-4 h-4 text-gray-500" />
                      <a href={`mailto:${booking.email}`} className="text-blue-600 hover:underline">{booking.email}</a>
                    </div>
                    <div className="flex items-center gap-2">
                      <Phone className="w-4 h-4 text-gray-500" />
                      <a href={`tel:${booking.phone}`} className="text-blue-600 hover:underline">{booking.phone}</a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-semibold">Date:</span> {booking.date}</div>
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-gray-500" />
                      <span className="font-semibold">Time:</span> {booking.timeSlot}
                    </div>
                    {booking.message && (
                      <div>
                        <span className="font-semibold">Message:</span>
                        <p className="text-gray-600 mt-1">{booking.message}</p>
                      </div>
                    )}
                    <div className="text-xs text-gray-500 mt-2">
                      Created: {formatDate(booking.createdAt)}
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    )}
  </div>
);

export default BookingsTab;
